document.addEventListener("DOMContentLoaded", function () {
  "use strict";
  // Class constructor for Komodo Toggle component.
  // Implements Komodo component design pattern
  //
  // @constructor
  // @param {HTMLElement} The element that will be upgraded to be Komodo Toggle.
  var KomodoToggle = function KomodoToggle(element) {
    this.element_ = element;
    var selectors = this.element_.getAttribute("data-toggle").split(",");
    this.components = [];
    for (var i = 0; i < selectors.length; i++) {
      var component = document.querySelector(selectors[i]);
      if (component) {
        this.components.push(component);
      }
    }
    this.dynamicClassList = this.element_
      .getAttribute("data-toggle-classes")
      .split(",");
    // Toggle Accordion
    if (!this.element_.disabled && this.components.length > 0) {
      // check if this check should be object type
      this.element_.addEventListener("click", this.toggleComponent.bind(this));
    }
  };

  const navElement = document.getElementById("mega-nav");
  const navContainer = document.getElementById("nav-container");
  const notificationContainer = document.getElementById("notification-dd");
  let navInstanciated = false;
  let previousMenuItem = null;


  window["KomodoToggle"] = KomodoToggle;
  // Store strings for class names defined by this component that are used in
  // Javascript. This allows us to simply change it in one place should we decide
  // to modify at a later date.
  //
  // @enum {string}
  // @private
  KomodoToggle.prototype.cssClasses_ = {
    component: "komodo-toggle-component",
  };
  // Toggle Component.
  //
  // @public
  KomodoToggle.prototype.toggleComponent = function (event) {
    if (this.element_ === event.target) {
      event.preventDefault();
    } else {
      event.stopPropagation();
    }

    var callback = function (evt) {
      // Check to see if the document is processing the same event that
      // displayed the menu in the first place. If so, do nothing.
      // Also check to see if the menu is in the process of closing itself, and
      // do nothing in that case.
      // Also check if the clicked element is a menu item
      // if so, do nothing.

      if (
        evt !== event &&
        this.components.indexOf(
          evt.target.closest("." + this.cssClasses_.component)
        ) == -1
      ) {
        document.removeEventListener("click", callback);

        const el = evt.target;
        const navContainerOpen = navContainer ? (navContainer.classList.contains("open")) : false;
        const isClickOnNav = navElement ? (el.id === navElement.id) : false;
        const isClickOutsideNavContainer = navContainer ? (!navContainer.contains(el)) : true;
        const isLinkClick = el.tagName === "A";
        const isClose = el.classList.contains("close");
        const isMenuItem = el.tagName === "LI"; // may need to make this stronger
        const isSamePreviousMenuItem = previousMenuItem === el;
        const isOpen = el.classList.contains("open");
        const shouldCloseNav =
          isSamePreviousMenuItem &&
          isMenuItem &&
          navContainerOpen && isOpen;


        if (
          navElement &&
          (isClickOutsideNavContainer ||
          isLinkClick ||
          isClose ||
          (isClickOnNav && navContainerOpen))
        ) {
          navElement.classList.remove("open");
        }

        let isNotificationReload = false;
        if (notificationContainer) {
          for (var i = 0; i < this.components.length; i++) {
            const currentElement = this.components[i];
            if (currentElement.id === notificationContainer.id && currentElement.getInnerHTML().includes("c-loader")) {
              isNotificationReload = true;
              break;
            }
          }
        }
        for (var i = 0; i < this.components.length; i++) {
          const currentEl = this.components[i];
          const isNav = navElement ? (currentEl.id === navElement.id) : false;
          const shouldClose =
            !navContainerOpen &&
            currentEl === el &&
            !currentEl.classList.contains("open");



          // skip nav toggle
          if (!isNav && !shouldCloseNav && !isNotificationReload) {
            this.components[i].dispatchEvent(
              componentHandler.createEvent(
                "hide.komodo.toggle",
                null,
                false,
                true
              )
            );

            this.components[i].classList.remove(this.dynamicClassList);

            this.components[i].dispatchEvent(
              componentHandler.createEvent(
                "hidden.komodo.toggle",
                null,
                false,
                true
              )
            );
          }
        }




        if (isMenuItem && previousMenuItem !== evt.target) {
          previousMenuItem = evt.target;
        }
      }
    }.bind(this);

    if (this.element_ === event.target) {
      const el = event.target;
      const isMenuItem = el.tagName === "LI"; // may need to make this stronger

      if (this.components[0].classList.contains(this.dynamicClassList)) {
        this.element_.dispatchEvent(
          componentHandler.createEvent("hide.komodo.toggle", null, false, true)
        );
      } else {
        this.element_.dispatchEvent(
          componentHandler.createEvent("show.komodo.toggle", null, false, true)
        );
      }
		// w/o using id selectors
		// on 1st click (hamburger-btn) parent is nav container or f.closest('.komodo-toggle-component'), f.closest('.komodo-toggle-component').querySelector('nav') -- nav
        // [...this.components].shift().querySelector('nav') -- finds nav
        // [...this.components].shift() -- nav container



      for (var i = 0; i < this.components.length; i++) {
        const currentEl = this.components[i];
        const isNav = navElement ? (currentEl.id === navElement.id) : false;
        const isChildOfNav = navElement ? (navElement.contains(currentEl) && !isNav) : false;
        const isParentContainer = navContainer ? (currentEl.id === navContainer.id) : false;
        const isSamePreviousMenuItem = previousMenuItem === el && isMenuItem;
        const toggleNavElement = navContainer ? (isNav && ((!isSamePreviousMenuItem && !currentEl.classList.contains("open")) || (isSamePreviousMenuItem && currentEl.classList.length !== navContainer.classList.length))) : false; // when previous is same
        const isClickOutsideNavContainer = navContainer ? (!navContainer.contains(currentEl)) : true;


        // skip nav toggle if child of nav, unless instanciated
        if (
          (isNav && window.innerWidth < 992) || // do not skip nav toggle if request is coming from mobile
          !navInstanciated ||
          isChildOfNav ||
          isParentContainer ||
          isClickOutsideNavContainer ||
          toggleNavElement
        ) {

          this.components[i].classList.toggle(this.dynamicClassList);
          navInstanciated = true;

         }

      }

      if (this.components[0].classList.contains(this.dynamicClassList)) {
        this.element_.dispatchEvent(
          componentHandler.createEvent("shown.komodo.toggle", null, false, true)
        );
      } else {
        this.element_.dispatchEvent(
          componentHandler.createEvent(
            "hidden.komodo.toggle",
            null,
            false,
            true
          )
        );
      }

    }

    document.addEventListener("click", callback);
  };

  KomodoToggle.prototype["toggleComponent"] =
    KomodoToggle.prototype.toggleComponent;

  // The component registers itself. It can assume componentHandler is available
  // in the global scape.
  componentHandler.register({
    constructor: KomodoToggle,
    classAsString: "KomodoToggle",
    cssClass: "komodo-toggle",
    widget: true,
  });
});
